// extracted by css-extract-rspack-plugin
export default {"wrapper":"FooterCellWrapper_wrapper__bA35s"};